var map = {
	"./zh-cn": 152,
	"./zh-cn.js": 152
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 403;


//////////////////
// WEBPACK FOOTER
// ./~/moment-cn/locale ^\.\/.*$
// module id = 403
// module chunks = 1